import React from 'react'

const data = {}

const GlobalContext = React.createContext(data)

export default GlobalContext
